import { config } from './main';

export function validateEmail(a) {
    var s = new RegExp(config.emailRegex);
    return s.test(a);
}

function checkPassword(a) {
    var s = new RegExp(config.passwordRegex);
    return s.test(a);
}

var validationEnabled = 1;

export function validate(a) {
    var s = !0,
        e = 'show-required',
        t = 'validate',
        i = a.closest('.validation-fields-container');
    return (
        i.hasClass('validate-red-container') && (t = 'validate-red'),
        i.find('input').each(function(a, i) {
            var l = $(i);
            l.removeClass('validate');
            var o = !1;
            ((l.closest('.other-person').length && !l.closest('.other-person').hasClass('show')) ||
                (l.hasClass('universal-field') && !l.hasClass(topisClass + '-visible')) ||
                (l.closest('.send-mail-info__other').length && !l.closest('.send-mail-info__other').hasClass('show')) ||
                (l.closest('.need-invoice-container').length &&
                    !l.closest('.need-invoice-container').hasClass('show')) ||
                (l.closest('.need-account-container').length &&
                    !l.closest('.need-account-container').hasClass('show'))) &&
                (o = !0),
                l.prop('required') &&
                    !o &&
                    ('' === l.val()
                        ? ((s = !1), l.addClass(t))
                        : l.hasClass('select__hour')
                        ? l.siblings('.select__button').addClass(t)
                        : l.hasClass('validate-email')
                        ? validateEmail(l.val()) || ((s = !1), l.addClass(t))
                        : l.hasClass('validate-password')
                        ? checkPassword($(this).val())
                            ? $('.validate-password-first').val() !== $('.validate-password-second').val()
                                ? ((e = 'show-code'), (s = !1))
                                : (s = !0)
                            : ((s = !1), l.addClass(t), (e = 'show-email'))
                        : l.hasClass('validate-checkbox') &&
                          l.prop('checked') === !1 &&
                          (l.parent().addClass(t), (s = !1)));
        }),
        i.find('.validation-texts-container').removeClass('show-required show-email show-inactive show-code show'),
        s || ((validationEnabled = !0), i.find('.validation-texts-container').addClass(e + ' show')),
        s
    );
}



// WEBPACK FOOTER //
// ./src/validation.js